import { render, staticRenderFns } from "./DropdownModal.vue?vue&type=template&id=15878de2&scoped=true"
import script from "./DropdownModal.vue?vue&type=script&lang=js"
export * from "./DropdownModal.vue?vue&type=script&lang=js"
import style0 from "./DropdownModal.vue?vue&type=style&index=0&id=15878de2&prod&lang=scss"
import style1 from "./DropdownModal.vue?vue&type=style&index=1&id=15878de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15878de2",
  null
  
)

export default component.exports